import { memo } from 'react';
import type { SxProps } from '@mui/material';
import TextField from '@mui/material/TextField';
import SearchIcon from '@material-ui/icons/Search';

import clsx from 'clsx';
import { useStyles, Container } from './style';

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  cls?: {
    root?: string;
  };
  sx?: SxProps;
}

const TableSearchBar: React.FC<Props> = ({
  value,
  onChange,
  placeholder,
  cls,
  sx,
}) => {
  const classes = useStyles();

  return (
    <Container className={cls?.root} sx={sx}>
      <TextField
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        classes={{
          root: classes.inputRoot,
        }}
        variant="standard"
        InputProps={{
          disableUnderline: true,
          classes: {
            input: classes.input,
          },
        }}
      />
      <SearchIcon className={classes.icon} />
    </Container>
  );
};

export default memo(TableSearchBar);
